import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environments/environment';

@Pipe({ name: 'oddFormat' })
export class oddFormatPipe implements PipeTransform {
  transform(value: number): string {
    try {
      const formatId = Number(localStorage.getItem('oddFormatId'));
      switch (formatId) {
        case 1: {
          // Decimal
          return this.converToDecimalFormat(value);
        }
        case 2: {
          // Fractional
          return this.converToFractionalFormat(value);
        }
        case 3: {
          // US
          return this.converToAmericanFormat(value);
        }
        case 4: {
          // HK
          return this.converToHongKongFormat(value);
        }

        case 5: {
          // Malay
          return this.converToMalayFormat(value);
        }
        case 6: {
          // Indo
          return this.converToIndoFormat(value);
        }
        default:
          return this.converToDecimalFormat(value);
      }
    } catch (error) {
      console.error('Odd pipe', error);
      return 'Odd pipe hata oluştu.';
    }
  }

  converToDecimalFormat(value) {
    if (Number.isFinite(value)) {
      return value.toFixed(2); // İki ondalık basamaklı format
    }

    return value;
  }
  converToFractionalFormat(value) {
    if (value === 0) {
      return '0/1';
    }

    let tolerance = 1.0e-6;
    let h1 = 1;
    let h2 = 0;
    let k1 = 0;
    let k2 = 1;
    let b = value;
    do {
      let a = Math.floor(b);
      let aux = h1;
      h1 = a * h1 + h2;
      h2 = aux;
      aux = k1;
      k1 = a * k1 + k2;
      k2 = aux;
      b = 1 / (b - a);
    } while (Math.abs(value - h1 / k1) > value * tolerance);

    if (isNaN(h1) || isNaN(k1)) {
      return '';
    }

    return h1 + '/' + k1;
  }
  converToAmericanFormat(value) {
    if (value > 2) {
      return `+${((value - 1) * 100).toFixed(0)}`;
    } else {
      return `-${(100 / (1 / (value - 1))).toFixed(0)}`;
    }
  }
  converToHongKongFormat(value) {
    if (!isNaN(value)) {
      return (value - 1).toFixed(2);
    }
  }
  converToMalayFormat(value) {
    // Verilen sayının negatifini alır.
    const negativeValue = -value;

    // Sayıyı virgülle böler ve kesir kısmını elde eder.
    const decimalPart = negativeValue.toFixed(2).split('.')[1];

    // Kesir kısmını iki basamaklı hale getirir.
    const formattedDecimalPart = decimalPart.padStart(2, '0');

    // Kesir kısmını birinci ve ikinci basamaklarını alır.
    const firstDigit = formattedDecimalPart.charAt(0);
    const secondDigit = formattedDecimalPart.charAt(1);

    // Malay formatına çevirir.
    const malayFormat = `-${firstDigit}.${secondDigit}`;

    return malayFormat;
  }
  converToIndoFormat(value) {
    // Verilen değeri 1 azaltırız.
    const decreasedValue = value - 1.0;

    // Sonucu döndürürüz.
    return decreasedValue.toFixed(2);
  }
}
